
import Main from "@/views/Main.vue";
const customerRoutes = [
  {
    path: "/mapping",
    icon: "android-menu",
    name: "MappingManager",
    title: "商品准入管理",
    component: Main,
    children: [
      {
        path: "globalMapping",
        title: "全局mapping",
        name: "GlobalMapping",
        component: (resolve) => {
          require(["@/views/mapping/cn/globalMapping.vue"], resolve);
        },
      },
      {
        path: "vendorMapping",
        title: "店铺mapping",
        name: "VendorMapping",
        component: (resolve) => {
          require(["@/views/mapping/vendorMapping.vue"], resolve);
        },
      },
      {
        path: "cn/vendorMapping",
        title: "店铺mapping（CN）",
        name: "VendorMapping",
        component: (resolve) => {
          require(["@/views/mapping/cn/vendorMapping.vue"], resolve);
        },
      },
      {
        path: "systemMapping",
        title: "系统mapping",
        name: "SystemMapping",
        component: (resolve) => {
          require(["@/views/mapping/cn/systemMapping.vue"], resolve);
        },
      },
      {
        path: "sizeClean",
        title: "尺码清洗",
        name: "sizeClean",
        component: (resolve) => {
          require(["@/views/mapping/sizeClean.vue"], resolve);
        },
      },
      {
        path: "vendorBrandMapping",
        title: "店铺品牌Mapping",
        name: "vendorBrandMapping",
        component: (resolve) => {
          require(["@/views/mapping/vendorBrandMapping.vue"], resolve);
        },
      },
      {
        path: "drafts",
        title: "补充SKU信息",
        name: "Drafts",
        component: (resolve) => {
          require(["@/views/mapping/drafts.vue"], resolve);
        },
      },
      {
        path: "brandCategoryBlack",
        title: "品牌品类黑名单",
        name: "brandCategoryBlack",
        component: (resolve) => {
          require(["@/views/mapping/cn/brandCategoryBlack.vue"], resolve);
        },
      },
      {
        path: "madeIn",
        title: "产地Mapping",
        name: "madeInMapping",
        component: (resolve) => {
          require(["@/views/mapping/cn/madeInMapping.vue"], resolve);
        },
      },
    ],
  },
];

export default customerRoutes
